import { Call } from '@/services/call-log-service/call-log-service.types';
import SmsLogo from '@/assets/icons/sms-logo.svg?react';
import EmailLogo from '@/assets/icons/email.svg?react';
import ChatBotLogo from '@/assets/icons/chatbot.svg?react';
import Icon from '@ant-design/icons';
import Pause from '@/assets/icons/pause-circle.svg?react';
import Live from '@/assets/icons/transcript.svg?react';
import Play from '@/assets/icons/play.svg?react';
import styles from './call-logs-table.module.scss';
import { Flex } from 'antd';
import { Button } from '../button/button';
import { calculateSecondsToMinutes } from '@/utils/helpers';
import { Dispatch, SetStateAction } from 'react';
import { LoadingOutlined } from '@ant-design/icons';

export const generateDataSource = (data: Call[]) => {
  return data?.map((element) => ({
    key: element.id,
    ...element,
  }));
};

export const getCallIcon = (
  call: Call,
  selectedRecord?: Call,
  isPlaying: boolean = false
): React.ReactElement => {
  if (call.status === 'live') {
    return <Live />;
  }

  if (call.id === selectedRecord?.id && isPlaying) {
    return <Pause />;
  }

  return <Play />;
};

export const renderCallIconWithDuration = (
  record: Call,
  duration: Call['duration'],
  selectedRecord?: Call,
  onSelectRecord?: (record: Call) => void,
  setIsPlaying?: Dispatch<SetStateAction<boolean>>,
  loadingRecordId?: number
) => {
  switch (record.type) {
    case 'TextConversation':
      return (
        <div className={styles.conversationIconWrapper}>
          <Icon className={styles.conversationIcon} component={SmsLogo} />
        </div>
      );

    case 'EmailConversation':
      return (
        <div className={styles.conversationIconWrapper}>
          <Icon className={styles.emailIcon} component={EmailLogo} />
        </div>
      );

    case 'ChatConversation':
      return (
        <div className={styles.conversationIconWrapper}>
          <Icon className={styles.chatbotIcon} component={ChatBotLogo} />
        </div>
      );

    case 'AgentCall':

    case 'AnalyticsCall':
      return (
        <Flex align="center" gap={8} className={styles.callIconWrapper}>
          {duration || record.status === 'live' ? (
            record.status === 'live' ? (
              <Icon className={styles.callIcon} component={() => getCallIcon(record)} />
            ) : (
              <Button
                className={
                  record.type === 'AgentCall' ? styles.playerButtonAgent : styles.playerButton
                }
                buttonVariant="secondary"
                onClick={(e) => {
                  e.stopPropagation();
                  onSelectRecord?.(record);
                  if (record.id === selectedRecord?.id && setIsPlaying) {
                    setIsPlaying((prev) => !prev);
                  }
                }}
                disabled={loadingRecordId === record.id}
              >
                {loadingRecordId === record.id ? (
                  <LoadingOutlined spin className={styles.playIcon} />
                ) : (
                  <Icon className={styles.playIcon} component={() => getCallIcon(record)} />
                )}
              </Button>
            )
          ) : (
            <p className={styles.noRecords}>---</p>
          )}

          <p>
            {duration || record.status === 'live'
              ? (record.status === 'live'
                  ? 'live'
                  : calculateSecondsToMinutes(duration || 0)
                ).toUpperCase()
              : ''}
          </p>
        </Flex>
      );

    default:
      return null;
  }
};
